export enum StatusEnum {
  STATUS_WAITING_DELIVERY = 'waiting_delivery',
  STATUS_IN_ANALYSIS = 'in_analysis',
  STATUS_DELIVERED = 'delivered',
  STATUS_PARTIALLY_DELIVERED = 'partially_delivered',
  STATUS_CANCELED = 'canceled',
}

export const StatusLabels: Record<StatusEnum, string> = {
  [StatusEnum.STATUS_WAITING_DELIVERY]: 'Aguardando entrega',
  [StatusEnum.STATUS_IN_ANALYSIS]: 'Em análise',
  [StatusEnum.STATUS_DELIVERED]: 'Entregue',
  [StatusEnum.STATUS_PARTIALLY_DELIVERED]: 'Entregue parcialmente',
  [StatusEnum.STATUS_CANCELED]: 'Cancelado',
};

export const StatusMap: Record<
  StatusEnum,
  {
    title: string;
    color: string;
    backgroundColor: string;
    icon: string;
  }
> = {
  [StatusEnum.STATUS_WAITING_DELIVERY]: {
    title: StatusLabels[StatusEnum.STATUS_WAITING_DELIVERY],
    color: '#185cfb',
    backgroundColor: '#e6f7ff',
    icon: 'clock-outline',
  },
  [StatusEnum.STATUS_IN_ANALYSIS]: {
    title: StatusLabels[StatusEnum.STATUS_IN_ANALYSIS],
    color: '#5a1a7d',
    backgroundColor: '#ebc7ff',
    icon: 'receipt',
  },
  [StatusEnum.STATUS_DELIVERED]: {
    title: StatusLabels[StatusEnum.STATUS_DELIVERED],
    color: '#009d19',
    backgroundColor: '#edfde7',
    icon: 'check-circle-outline',
  },
  [StatusEnum.STATUS_PARTIALLY_DELIVERED]: {
    title: StatusLabels[StatusEnum.STATUS_PARTIALLY_DELIVERED],
    color: '#926e00',
    backgroundColor: '#fefbe1',
    icon: 'clock-check-outline',
  },
  [StatusEnum.STATUS_CANCELED]: {
    title: StatusLabels[StatusEnum.STATUS_CANCELED],
    color: '#db082c',
    backgroundColor: '#ffede5',
    icon: 'close-circle-outline',
  },
};
